









































































































































import { defineComponent, PropType } from '@vue/composition-api';

import AtomAlert from '@/components/atoms/AtomAlert.vue';
import AtomButton from '@/components/atoms/AtomButton.vue';
import AtomDivider from '@/components/atoms/AtomDivider.vue';
import GuideImageText from '@/components/molecules/GuideImageText.vue';
import HeadingCenter from '@/components/molecules/HeadingCenter.vue';
import HeadingLeft from '@/components/molecules/HeadingLeft.vue';
import NavPrev from '@/components/atoms/NavPrev.vue';
import PointList from '@/components/atoms/PointList.vue';
import WrapperCard from '@/components/atoms/WrapperCard.vue';

import AdvisorSearchForm from '@/modules/advisor-search/organisms/AdvisorSearchForm/AdvisorSearchForm.vue';
import AdvisorSearchUsers from '@/modules/advisor-search/organisms/AdvisorSearchUsers.vue';
import AdvisorSearchPagination from '@/modules/advisor-search/organisms/AdvisorSearchPagination.vue';
import AdvisorSearchSideMenu from '@/modules/advisor-search/organisms/AdvisorSearchSideMenu.vue';

import { useAdvisorSearchUsersPage } from '@/modules/advisor-search/pages/AdvisorSearchUsersPage';

export default defineComponent({
  name: 'AdvisorSearchUsersPage',
  components: {
    AtomAlert,
    AtomButton,
    AtomDivider,
    GuideImageText,
    HeadingCenter,
    HeadingLeft,
    NavPrev,
    PointList,
    WrapperCard,

    AdvisorSearchForm,
    AdvisorSearchUsers,
    AdvisorSearchPagination,
    AdvisorSearchSideMenu,
  },
  props: {
    userId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    isRequester: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const {
      query,
      page,
      data,
      error,
      isValidating,
      isCached,
      heading,
      showPagination,
      onClickLink,
    } = useAdvisorSearchUsersPage(context, false);

    return {
      query,
      page,
      data,
      error,
      isValidating,
      isCached,
      heading,
      showPagination,
      onClickLink,
    };
  },
});
